import firebase from "firebase";
import { Wallet } from "../../models/wallet";

export const serializeWalletSnap = (
  walletSnap: firebase.firestore.DocumentSnapshot
): Wallet => {
  const data = walletSnap.data() ?? {};
  return serializeWallet(data);
};

export const serializeWallet = (data: firebase.firestore.DocumentData): Wallet => ({
  balance: data.balance ?? 0
});
